import { Message } from '@kvdbil/components';
import React from 'react';
import StatusPageContainer from '~/App/shared/components/StatusPageContainer';
import { useTranslation } from '~/Locale';

interface Props {
  message?: string;
  minHeight?: number;
  unit?: 'rem' | 'vh';
}

const StatusPageError = ({ message, minHeight = 50, unit }: Props) => {
  const { t } = useTranslation();
  return (
    <StatusPageContainer $minHeight={minHeight} $unit={unit}>
      <Message withIcon type="error">
        {message ?? t('Something went wrong, please try again later.')}
      </Message>
    </StatusPageContainer>
  );
};

export default StatusPageError;
